import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef
} from "@angular/core";

@Component({
  selector: "app-search-list",
  templateUrl: "./search-list.component.html",
  styleUrls: ["./search-list.component.scss"]
})
export class SearchListComponent implements OnInit {
  @Input() searchTerm: string = "";
  @Output() onSearchInputUpdate = new EventEmitter();
  @ViewChild("searchInput") searchInputField: ElementRef;

  public searchFocus: boolean;

  private searchTermTimeoutId;
  private waitTime: number = 500; // half a second

  constructor() {}

  ngOnInit() {
    this.searchFocus = false;
    this.searchInputField.nativeElement.value = this.searchTerm;
  }

  onFocus(event) {
    this.searchFocus = true;
  }

  onBlur(event) {
    // setTimeout so clearSearch click event has time to be called first
    setTimeout(() => {
      if (event.srcElement.value.length === 0) {
        this.searchFocus = false;
      }
    }, 100);
  }

  onKeyUp(event) {
    if (this.searchTermTimeoutId) {
      clearTimeout(this.searchTermTimeoutId);
    }
    this.searchTermTimeoutId = setTimeout(() => {
      this.onSearchInputUpdate.emit(this.searchInputField.nativeElement.value);
    }, this.waitTime);
  }

  clearSearch() {
    this.searchFocus = false;
    this.searchInputField.nativeElement.value = "";
    this.onSearchInputUpdate.emit("");
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/search-list/search-list.component.ts